'use client';
import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslations } from 'next-intl';

import { DocumentFile } from '@peerless/data-access/strapi';
import { useAuthenticated } from '@peerless/ui-amplify';
import { ButtonLink, Document, DocumentDisplay } from '@peerless/ui-shared';
import { EtilizeProductModel } from '@peerless/data-access/etilize-api-client';
import { isNorthAmerica, useCurrentLocale } from '@peerless/ui-locale';

interface Props {
  product: EtilizeProductModel;
  file: DocumentFile;
}

export const ProtectedDocument: React.FC<Props> = ({ product, file }) => {
  const t = useTranslations('ProductDocuments');
  const auth = useAuthenticated();
  const { region } = useCurrentLocale();
  const [isOpen, setIsOpen] = useState(false);
  const productUrl = `/products/${encodeURIComponent(product.mfgPartNumber)}`;

  return (
    <>
      {auth || isNorthAmerica(region) ? (
        <Document file={file} />
      ) : (
        <button
          type="button"
          style={{
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            padding: 0,
            width: '100%',
          }}
          onClick={() => setIsOpen(true)}
        >
          <DocumentDisplay file={file} />
        </button>
      )}
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle>{t('protected-title')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('protected-description')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonLink
            href={`/sign-in?returnUrl=${encodeURIComponent(productUrl)}`}
            variant="contained"
            color="primary"
          >
            {t('protected-login')}
          </ButtonLink>
          <Button onClick={() => setIsOpen(false)} color="secondary">
            {t('protected-close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
